export default {
  UPDATE_PREFERENCES: '@@COMMS_PREFS/UPDATE_PREFERENCES',
  GET_PREFERENCES: '@@COMMS_PREFS/GET_PREFERENCES',
  UPDATE_PREFERENCES_SUCCESS: '@@COMMS_PREFS/UPDATE_PREFERENCES_SUCCESS',
  GET_PREFERENCES_SUCCESS: '@@COMMS_PREFS/GET_PREFERENCES_SUCCESS',
  UPDATE_PREFERENCES_ERROR: '@@COMMS_PREFS/UPDATE_PREFERENCES_ERROR',
  GET_PREFERENCES_ERROR: '@@COMMS_PREFS/GET_PREFERENCES_ERROR',
  CREATE_PREFERENCES_ERROR: '@@COMMS_PREFS/CREATE_PREFERENCES_ERROR',
  TOGGLE_CHECKBOX: '@@COMMS_PREFS/TOGGLE_CHECKBOX',
  WAITING_FOR_RESPONSE: '@@COMMS_PREFS/WAITING_FOR_RESPONSE',
  SHOW_UNSUB_NOTIFICATION: '@@COMMS_PREFS/SHOW_UNSUB_NOTIFICATION',
  HIDE_UNSUB_NOTIFICATION: '@@COMMS_PREFS/HIDE_UNSUB_NOTIFICATION',

  SIGN_IN_SUBMIT: '@@SIGN_IN/SUBMIT',
  SIGN_IN_CREDENTIALS_ERROR: '@@SIGN_IN/CREDENTIALS_ERROR',
  SIGN_IN_PASSWORD_RESET_REQUIRED_ERROR: '@@SIGN_IN/PASSWORD_RESET_REQUIRED_ERROR',
  SIGN_IN_USER_DISABLED_ERROR: '@@SIGN_IN/SIGN_IN_USER_DISABLED_ERROR',
  SIGN_IN_EMAIL_CHANGE: '@@SIGN_IN/EMAIL_CHANGE',
  SIGN_IN_COGNITO_ERROR: '@@SIGN_IN/COGNITO_ERROR',
  SIGN_IN_SUCCESS: '@@SIGN_IN/SUCCESS',
  SIGN_IN_MODAL_CLOSE: '@@SIGN_IN/MODAL_CLOSE',
  SIGN_IN_REDIRECT: '@@SIGN_IN/REDIRECT',
  SIGN_IN_SHOW: '@@SIGN_IN/SHOW',

  REGISTER_SESSION_AUTH_ERROR_DURING_SIGN_IN: 'REGISTER_SESSION_AUTH_ERROR_DURING_SIGN_IN',
  SIGN_IN_SESSION_AUTH_ERROR: 'SIGN_IN_SESSION_AUTH_ERROR',

  SIGN_OUT: 'SIGN_OUT',
  CONTINUE_WITH_FACEBOOK: 'CONTINUE_WITH_FACEBOOK',
  SIGNED_IN_VIA_FACEBOOK: 'SIGNED_IN_VIA_FACEBOOK',

  MODAL_CHECK: 'MODAL_CHECK',
  SHOW_MODAL: 'SHOW_MODAL',

  REGISTER_SUBMIT: '@@REGISTER/SUBMIT',
  REGISTER_EMAIL_ALREADY_TAKEN: '@@REGISTER/EMAIL_ALREADY_TAKEN',
  REGISTER_PASSWORD_ERROR: '@@REGISTER/PASSWORD_ERROR',
  REGISTER_COGNITO_ERROR: '@@REGISTER/COGNITO_ERROR',

  RECAPTCHA_CHECK: '@@REGISTER/RECAPTCHA_CHECK',
  RECAPTCHA_REQUIRED: '@@REGISTER/RECAPTCHA_REQUIRED',
  RECAPTCHA_ERROR: '@@REGISTER/RECAPTCHA_ERROR',

  START_APP: '@@START_APP',
};
